// extracted by mini-css-extract-plugin
export default {"container":"LabelWithHint_container__b+t+H"};